<template>
  <generic-modal
    size="medium"
    :title="$t('graphic card')"
    icon="cube"
    image="/images/icons/graphic_card.png"
    :show_ok="true"
    :scrolling="true"
    v-on:destroy="$emit('close')"
    :on_finished="on_finished"
    :footer_buttons="footer_buttons"
    ref="modal"
  >
    <div class="description">
      <div class="ui form">
        <div class="ui grid">
          <div class="ten wide column">
            <div class="two fields">
              <div class="field">
                <label for="">{{ $t("name") }}</label>
                <input type="text" name="name" v-model="setup.name" />
              </div>
              <div class="field">
                <label for="">{{ $t("type") }}</label>
                <select
                  class="ui selection dropdown"
                  ref="type_dropdown"
                  v-model="setup.type"
                >
                  <option value="">{{ $t("select one") }}</option>
                  <option value="rtx">RTX</option>
                  <option value="gtx">GTX</option>
                </select>
              </div>
            </div>
          </div>
          <div class="six wide column">
            <div class="field">
              <label for="">{{ $t("type") }}</label>
              <div class="field">
                <div class="ui toggle checkbox">
                  <input
                    type="checkbox"
                    name="laptop"
                    v-model="setup.for_laptop"
                  />
                  <label>{{ $t("for laptop") }}</label>
                </div>
              </div>
              <div class="field">
                <div class="ui toggle checkbox">
                  <input
                    type="checkbox"
                    name="desktop"
                    v-model="setup.for_desktop"
                  />
                  <label>{{ $t("for desktop") }}</label>
                </div>
              </div>
              <div class="field">
                <div class="ui toggle checkbox">
                  <input
                    type="checkbox"
                    name="discrete"
                    v-model="setup.for_discrete"
                  />
                  <label>{{ $t("discrete") }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";

export default {
  name: "NvidiaBundleGraphicCardModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  props: {
    selected_card: Object,
  },
  data() {
    return {
      id: "",
      setup: {
        name: "",
        for_laptop: false,
        for_desktop: false,
        for_discrete: false,
        type: "",
      },
      footer_buttons: [
        {
          icon: "trash",
          color: "red",
          text: this.$t("delete"),
          click: this.remove,
        },
      ],
    };
  },
  methods: {
    on_finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/nvidia_bundle/graphic_card/do-save", {
          setup: vm.setup,
          gci: vm.id,
        })
          .then(function(r) {
            resolve(r);
          })
          .catch(function(err) {
            reject(err);
          });
      });
    },
    remove() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove graphic card?"),
        function() {
          local_api(vm, "post", "/nvidia_bundle/graphic_card/do-remove", {
            u: vm.id,
          })
            .then(() => {
              // console.log("graphic card removed");
              vm.$refs.modal.hide();
              // vm.$emit("removed");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.type_dropdown).dropdown();
    // console.log("mountedxx");
    setTimeout(() => {
      if (vm.selected_card) {
        // console.log("init graphic card");
        vm.setup = vm.selected_card.setup;
        vm.id = vm.selected_card.graphic_card_id;

        if (vm.setup.type) {
          window
            .jQuery(vm.$refs.type_dropdown)
            .dropdown("set selected", vm.setup.type);
        }
      }
    }, 100);
  },
  watch: {},
  updated: function() {},
};
</script>
